module.exports = __webpack_public_path__ + "static/media/9-item-b.05b1d5e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/women/9-item-b.jpg
// module id = 1216
// module chunks = 33